// src/types/AiChatArtifact.ts
var AiChatArtifactType = /* @__PURE__ */ ((AiChatArtifactType2) => {
  AiChatArtifactType2["Property"] = "property";
  AiChatArtifactType2["SearchIntent"] = "search_intent";
  AiChatArtifactType2["MapDirection"] = "map_direction";
  AiChatArtifactType2["BookingList"] = "booking_list";
  AiChatArtifactType2["BookingSummary"] = "booking_summary";
  AiChatArtifactType2["BookingTrends"] = "booking_trends";
  AiChatArtifactType2["ReviewsSummary"] = "reviews_summary";
  AiChatArtifactType2["PlatformCounts"] = "platform_counts";
  AiChatArtifactType2["FinanceSummary"] = "finance_summary";
  AiChatArtifactType2["AiUsageSummary"] = "ai_usage_summary";
  AiChatArtifactType2["MessageSubject"] = "message_subject";
  AiChatArtifactType2["ListingComparison"] = "listing_comparison";
  AiChatArtifactType2["ListingFacts"] = "listing_facts";
  AiChatArtifactType2["GuestTrips"] = "guest_trips";
  AiChatArtifactType2["ShiftBriefing"] = "shift_briefing";
  return AiChatArtifactType2;
})(AiChatArtifactType || {});

export {
  AiChatArtifactType
};
